<template>
    <header class="m-h5-app-header" :class="headerClass" v-if="visible">
        <button class="u-back" type="button" :aria-label="$t('common.back')" @click="goBack" v-if="showBack">
            <el-icon><ArrowLeft /></el-icon>
        </button>
        <span class="u-back-placeholder" aria-hidden="true" v-else></span>
        <h1 class="u-title">{{ title }}</h1>
        <span class="u-action-placeholder" aria-hidden="true"></span>
    </header>
</template>

<script>
import { ArrowLeft } from "@element-plus/icons-vue";
import { isMiniProgramWebview } from "@/utils/miniprogram-bridge";

function pickRouteText(value) {
    if (Array.isArray(value)) {
        return value.find(Boolean) || "";
    }

    return value || "";
}

export default {
    name: "AppHeader",
    components: {
        ArrowLeft,
    },
    computed: {
        visible() {
            return this.$route.meta?.h5Header === true && !isMiniProgramWebview() && !!this.title;
        },
        title() {
            const queryTitle = pickRouteText(this.$route.query.title);
            if (queryTitle) return queryTitle;

            const titleKey =
                pickRouteText(this.$route.query.titleKey) || this.$route.meta?.h5TitleKey || this.$route.meta?.titleKey;
            if (titleKey) return this.$t(titleKey);

            return this.$route.meta?.h5Title || this.$route.meta?.title || "";
        },
        showBack() {
            return this.$route.meta?.h5Back !== false;
        },
        headerClass() {
            return {
                "is-brand": this.$route.meta?.h5HeaderTone === "brand",
            };
        },
    },
    methods: {
        goBack() {
            const fallback = this.$route.meta?.h5BackFallback || { name: "user_info" };
            if (window.history.length > 1) {
                this.$router.back();
                return;
            }

            this.$router.replace(fallback);
        },
    },
};
</script>

<style scoped>
.m-h5-app-header {
    position: sticky;
    top: 0;
    z-index: 80;
    display: grid;
    min-height: calc(3.5rem + var(--app-safe-area-top, 0px));
    grid-template-columns: 3.5rem minmax(0, 1fr) 3.5rem;
    align-items: end;
    box-sizing: border-box;
    padding-top: var(--app-safe-area-top, 0px);
    border-bottom: 0.0625rem solid rgba(18, 43, 78, 0.06);
    background: rgba(255, 255, 255, 0.96);
    color: #182235;
}

.m-h5-app-header.is-brand {
    border-bottom-color: rgba(255, 255, 255, 0.12);
    background: linear-gradient(180deg, #0e2d68 0%, #00296c 100%);
    color: #fff;
}

.u-back,
.u-back-placeholder,
.u-action-placeholder {
    display: inline-flex;
    width: 3.5rem;
    height: 3.5rem;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.u-back {
    border: 0;
    background: transparent;
    color: #146fd8;
    font: inherit;
    cursor: pointer;
}

.u-back .el-icon {
    font-size: 1.35rem;
}

.m-h5-app-header.is-brand .u-back,
.m-h5-app-header.is-brand .u-title {
    color: #fff;
}

.u-title {
    min-width: 0;
    margin: 0;
    align-self: center;
    overflow: hidden;
    color: #182235;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
